import React, { useEffect, useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { getSocket } from "../context/socket";
import { useAuth } from "../context/AuthContext";

const Activity = ({ cardId }) => {
    const socket = getSocket();
    const { userId } = useAuth();

    const [showDetails, setShowDetails] = useState(true);
    const [value, setValue] = useState('');
    const [activities, setActivities] = useState([]);

    const toggleDetails = () => setShowDetails(prev => !prev);

    useEffect(() => {
        if (!socket || !cardId) return;

        // Emit to fetch card activity
        socket.emit('getCardActivity', { card_id: cardId });

        // Listen for the data
        socket.on('cardActivityData', ({ card_id, activities }) => {
            if (card_id === cardId) {
                setActivities(activities);
            }
        });

       
        return () => {
            socket.off('cardActivityData');
        };
    }, [socket, cardId]);
    return (
        <>
            <div className="d-flex justify-content-between align-items-start mb-3">
                <h6><i className="pi pi-list-check me-2"></i> <b>Activity</b></h6>
                <Button
                    tooltip={showDetails ? "Hide Details" : "Show Details"}
                    icon={showDetails ? "pi pi-eye-slash" : "pi pi-eye"}
                    className="p-0 border-0"
                    text
                    style={{ width: '30px' }}
                    severity="secondary"
                    onClick={toggleDetails}
                />
            </div>

            {/* <div className="d-flex align-items-center gap-3 mb-2 mt-3">
                <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" style={{ width: '32px', height: '32px' }} />
                <div className="d-flex align-items-center gap-2" style={{ width: '100%' }}>
                    <InputTextarea 
                        value={value} 
                        onChange={(e) => setValue(e.target.value)} 
                        className="w-100 px-2 py-1 w-100" 
                        style={{ height: '36px'}} 
                        placeholder="Write a comment..."
                    />
                    <Button
                        label="Save"
                        className="py-1 border-0 ms-2"
                        severity="info"
                    />
                </div>
            </div> */}

            {showDetails && (
                <div className="mt-3" style={{maxHeight:'350px', overflowY: 'auto'}}>
                    {activities.length === 0 ? (
                        <p className="text-muted"><small>No activity yet.</small></p>
                    ) : (
                        activities.map((activity, index) => (
                            <div className="d-flex align-items-start gap-3 mb-3" key={index}>
                                <Avatar 
                                    image={activity.user_details?.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png"} 
                                    shape="circle" 
                                    style={{ width: '32px', height: '32px' }} 
                                />
                                <div>
                                    <p className="mb-1">
                                        <small>
                                            <b>{activity.user_details?.first_name} {activity.user_details?.last_name}</b> {activity.activity}
                                        </small>
                                    </p>
                                    <small className="text-secondary" style={{ fontSize: '12px' }}>
                                        {new Date(activity.created_date).toLocaleString()}
                                    </small>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </>
    );
};

export default Activity;
